/**
 * Resource danh mục tài sản
 * ndquang1 16.5.2024
 */
export default {
  Title: 'Tài sản tang vật',
  AssetCode: 'Mã tài sản *',
  AssetCodeTitle: 'Mã tài sản',
  AssetName: 'Tên tài sản *',
  AssetNameTitle: 'Tên tài sản',
  AssetCategory: 'Loại tài sản *',
  AssetCategoryTitle: 'Loại tài sản',
  Unit: 'Đơn vị tính',
  UnitPrice: 'Đơn giá',
  JusticeDecision: 'Quyết định',
  Stock: 'Kho ngầm định',
  Specification: 'Mô tả',
  Description: 'Ghi chú',
  Area: 'Khu vực',
  AreaTitle: 'Khu vực',
};
